import {
  BarChart3,
  ChefHat,
  FlaskConical,
  LogOut,
  Scale,
  Users,
  UsersRound,
  X,
} from 'lucide-react';

import { useAuth } from '@/auth/AuthContext';
import { cn } from '@/lib/utils';

const navItems = [
  { href: '/', label: 'Dashboard', icon: BarChart3 },
  { href: '/ingredients', label: 'Ingrédients', icon: ChefHat },
  { href: '/techniques', label: 'Techniques', icon: FlaskConical },
  { href: '/conversions', label: 'Conversions', icon: Scale },
  { href: '/users', label: 'Utilisateurs', icon: Users },
  { href: '/families', label: 'Familles', icon: UsersRound },
];

interface SidebarProps {
  isOpen?: boolean;
  onClose?: () => void;
}

export function Sidebar({ isOpen = false, onClose }: SidebarProps) {
  const { signOut } = useAuth();
  const currentPath = window.location.pathname;

  return (
    <aside
      style={{ width: 'var(--sidebar-width)' }}
      className={cn(
        'fixed inset-y-0 left-0 z-50 flex h-screen flex-col border-r border-slate-200 bg-white transition-transform duration-300 ease-in-out md:relative md:translate-x-0',
        isOpen ? 'translate-x-0 shadow-2xl' : '-translate-x-full',
      )}
    >
      {/* Logo */}
      <div className="flex h-[var(--topbar-height)] items-center justify-between border-b border-slate-200 px-5">
        <div className="flex items-center gap-2.5">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-green-600">
            <span className="text-sm font-bold text-white">FC</span>
          </div>
          <div>
            <p className="text-sm font-semibold text-slate-900">FamilyChef</p>
            <p className="text-xs text-slate-500">Administration</p>
          </div>
        </div>

        {onClose && (
          <button
            onClick={onClose}
            className="rounded-md p-1.5 text-slate-500 hover:bg-slate-100 md:hidden"
            aria-label="Fermer le menu"
          >
            <X size={20} />
          </button>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto p-3">
        <ul className="space-y-0.5">
          {navItems.map((item) => {
            const isActive =
              item.href === '/' ? currentPath === '/' : currentPath.startsWith(item.href);
            const Icon = item.icon;
            return (
              <li key={item.href}>
                <a href={item.href} className={cn('sidebar-link', isActive && 'active')}>
                  <Icon size={18} />
                  {item.label}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Footer */}
      <div className="border-t border-slate-200 p-3">
        <button
          onClick={() => void signOut()}
          className="sidebar-link w-full text-left text-red-500 hover:!bg-red-50 hover:!text-red-600"
        >
          <LogOut size={18} />
          Déconnexion
        </button>
      </div>
    </aside>
  );
}
